/**
 * custom.js - Espírito Livre
 * - Intercept add-to-cart via AJAX (POST /cart/add.js)
 * - Fly-to-cart animation, badge, confetti
 * - Sticky "Comprar Agora" robusto (abre quick-buy sheet no mobile)
 * - Bindings idempotentes / capture to avoid double actions
 * - Compatível com themes 2.0 / reconstrói DOM
 *
 * Cole todo esse arquivo e recarregue a página (limpe cache se necessário).
 */

(function () {
  'use strict';

  /* ====================== CONFIG ====================== */
  const MOBILE_BREAK = 989;
  const SELECTORS = {
    productForm: '.product-form, form[action*="/cart/add"]',
    addToCartBtn: 'button[name="add"], [data-add-to-cart], .add-to-cart, button.add-to-cart',
    buyNowCTAs: [
      '.shopify-payment-button__button--unbranded',
      '.product-form__submit',
      'button[name="buy_now"]',
      'button[data-action="buy-now"]',
      '.product-form__buttons [data-shopify="payment-button"]',
      '.product-form__buttons .shopify-payment-button__button',
      'button[type="submit"].button--buy-now',
      '.button--buy-now'
    ].join(','),
    productImage: '.product__media img, .product-media img, img[data-media-id], .product__image img',
    cartCount: '[data-cart-count], .cart-count, .header-cart-count, .js-cart-count',
    miniCart: '#mini-cart, .mini-cart, [data-mini-cart]',
    miniCartItems: '[data-cart-items], .mini-cart__items, .mini-cart-items',
    headerCartIcon: '[data-cart-icon], .site-header__cart, .header__icons a[href*="/cart"], a[href="/cart"]'
  };
  const API = {
    add: '/cart/add.js',
    cart: '/cart.js'
  };

  /* ====================== UTIL ====================== */
  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }
  function elReady(sel, timeout = 3000) {
    return new Promise((resolve) => {
      const e = qs(sel);
      if (e) return resolve(e);
      const mo = new MutationObserver(() => {
        const found = qs(sel);
        if (found) {
          mo.disconnect();
          resolve(found);
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => { mo.disconnect(); resolve(null); }, timeout);
    });
  }
  function formatPrice(cents) {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents/100); }
    catch(e) { return 'R$ ' + (cents/100).toFixed(2); }
  }

  /* ====================== FIND CART ICON (for fly target) ====================== */
  function findCartIcon() {
    let el = qs(SELECTORS.headerCartIcon) || document.getElementById('cart-button');
    if (el) return el;
    // fallback: look for element with cart text or svg
    el = Array.from(document.querySelectorAll('a,button,div')).find(n => {
      try {
        const a = (n.getAttribute('aria-label')||'') + ' ' + (n.getAttribute('title')||'') + ' ' + (n.textContent||'');
        return /carrinho|cart|sacola|bag/i.test(a);
      } catch(e){ return false; }
    });
    return el || document.body;
  }

  /* ====================== FLY ANIMATION + BADGE + CONFETTI ====================== */
  function flyToCartAnimation(imgEl, cartBtn) {
    return new Promise(resolve => {
      try {
        if (!imgEl) return resolve();
        const rectImg = imgEl.getBoundingClientRect();
        const rectCart = (cartBtn && cartBtn.getBoundingClientRect()) || { left: window.innerWidth - 48, top: 10, width: 40, height: 40 };
        const clone = imgEl.cloneNode(true);
        clone.style.position = 'fixed';
        clone.style.left = rectImg.left + 'px';
        clone.style.top = rectImg.top + 'px';
        clone.style.width = rectImg.width + 'px';
        clone.style.height = rectImg.height + 'px';
        clone.style.transition = 'transform .85s cubic-bezier(.2,.85,.2,1), opacity .6s';
        clone.style.zIndex = 999999;
        clone.style.borderRadius = '8px';
        clone.style.pointerEvents = 'none';
        document.body.appendChild(clone);
        // reflow
        clone.getBoundingClientRect();
        const translateX = rectCart.left + rectCart.width/2 - (rectImg.left + rectImg.width/2);
        const translateY = rectCart.top + rectCart.height/2 - (rectImg.top + rectImg.height/2);
        const scale = 0.14;
        clone.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
        clone.style.opacity = '0.0';

        setTimeout(() => {
          clone.remove();
          // small badge
          showAddedBadge({ x: rectCart.left + rectCart.width/2, y: rectCart.top });
          // confetti
          launchConfetti(rectCart.left + rectCart.width/2, rectCart.top + rectCart.height/2);
          resolve();
        }, 800);
      } catch(e) { resolve(); }
    });
  }

  function showAddedBadge(coordsOrEl) {
    try {
      const badge = document.createElement('div');
      badge.className = 'el-added-badge';
      badge.textContent = 'ADICIONADO ✅';
      badge.style.position = 'fixed';
      badge.style.zIndex = 999999;
      badge.style.padding = '8px 12px';
      badge.style.borderRadius = '20px';
      badge.style.background = 'linear-gradient(90deg,#23d07f,#06c2d7)';
      badge.style.color = '#02121a';
      badge.style.fontWeight = '800';
      badge.style.boxShadow = '0 8px 26px rgba(0,0,0,.35)';
      badge.style.opacity = '0';
      badge.style.transition = 'opacity .4s, transform .4s';
      if (coordsOrEl && coordsOrEl.left !== undefined) {
        badge.style.left = (coordsOrEl.left - 40) + 'px';
        badge.style.top = (coordsOrEl.top - 50) + 'px';
      } else if (coordsOrEl && coordsOrEl.getBoundingClientRect) {
        const r = coordsOrEl.getBoundingClientRect();
        badge.style.left = (r.left + r.width/2 - 60) + 'px';
        badge.style.top = (r.top - 40) + 'px';
      } else {
        badge.style.right = '20px';
        badge.style.bottom = '84px';
      }
      document.body.appendChild(badge);
      requestAnimationFrame(()=> { badge.style.opacity = '1'; badge.style.transform = 'translateY(-6px)'; });
      setTimeout(()=> { badge.style.opacity = '0'; setTimeout(()=> badge.remove(), 360); }, 1600);
    } catch(e){}
  }

  // minimal confetti with CSS particles (no libs)
  function launchConfetti(cx = window.innerWidth/2, cy = window.innerHeight/3) {
    try {
      const root = document.createElement('div');
      root.style.position = 'fixed';
      root.style.left = '0';
      root.style.top = '0';
      root.style.width = '100%';
      root.style.height = '100%';
      root.style.pointerEvents = 'none';
      root.style.zIndex = 2147483646;
      document.body.appendChild(root);

      const colors = ['#39e7ff', '#a0ff5a', '#ff6ad5', '#ffd36a', '#6f7cff'];
      for (let i=0;i<28;i++){
        const p = document.createElement('div');
        p.style.position = 'absolute';
        p.style.width = (6 + Math.random()*8) + 'px';
        p.style.height = p.style.width;
        p.style.left = (cx + (Math.random()*160-80)) + 'px';
        p.style.top  = (cy + (Math.random()*40-20)) + 'px';
        p.style.background = colors[Math.floor(Math.random()*colors.length)];
        p.style.borderRadius = (Math.random()>0.5? '2px':'50%');
        p.style.opacity = '0.95';
        p.style.transform = `translate3d(0,0,0) rotate(${Math.random()*360}deg)`;
        p.style.transition = `transform ${900 + Math.random()*800}ms cubic-bezier(.2,.9,.2,1), opacity 900ms linear`;
        root.appendChild(p);
        // animate
        requestAnimationFrame(()=> {
          p.style.transform = `translate3d(${(Math.random()*220-110)}px, ${400 + Math.random()*300}px, 0) rotate(${Math.random()*720}deg)`;
          p.style.opacity = '0';
        });
      }
      setTimeout(()=> root.remove(), 1600);
    } catch(e){}
  }

  /* ====================== CART UI REFRESH ====================== */
  async function refreshCartUI(openCart=false) {
    try {
      const res = await fetch(API.cart, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart fetch failed');
      const cart = await res.json();
      // update counters
      qsa(SELECTORS.cartCount).forEach(el => el.textContent = cart.item_count);
      // subtotal
      qsa('.cart-subtotal, .mini-cart__subtotal, .cart-subtotal-price').forEach(el => el.textContent = formatPrice(cart.items_subtotal_price));
      // mini-cart items
      const container = qs(SELECTORS.miniCartItems);
      if (container) {
        container.innerHTML = '';
        if (cart.items && cart.items.length) {
          cart.items.forEach(item => {
            const wrapper = document.createElement('div');
            wrapper.className = 'mini-cart__item';
            wrapper.innerHTML = `
              <div class="mini-cart__thumb"><img src="${item.image}" alt="${item.title}" width="64" height="64"></div>
              <div class="mini-cart__meta">
                <div class="mini-cart__title">${item.product_title}${item.variant_title ? ' - ' + item.variant_title : ''}</div>
                <div class="mini-cart__qty">Qtd: ${item.quantity}</div>
                <div class="mini-cart__price">${formatPrice(item.price)}</div>
              </div>
            `;
            container.appendChild(wrapper);
          });
        } else {
          container.innerHTML = '<div class="mini-cart__empty">Seu carrinho está vazio.</div>';
        }
      }
      if (openCart) {
        const mini = qs(SELECTORS.miniCart);
        if (mini) { mini.classList.add('open'); mini.setAttribute('aria-hidden','false'); }
      }
      // dispatch custom event
      window.dispatchEvent(new CustomEvent('el:cart:updated', { detail: cart }));
    } catch(e) {
      console.warn('refreshCartUI error', e);
    }
  }

  /* ====================== AJAX ADD TO CART (interceptor) ====================== */
  let isAdding = false;
  async function addToCartAjax(form, extras = {}) {
    // get variant id
    let idInput = form.querySelector('input[name="id"], select[name="id"], input[name="variant_id"]');
    let qtyInput = form.querySelector('input[name="quantity"], input.quantity') || { value: 1 };
    const id = (idInput && (idInput.value || (idInput.options && idInput.options[idInput.selectedIndex] && idInput.options[idInput.selectedIndex].value))) || extras.id;
    const quantity = parseInt(qtyInput.value || extras.quantity || 1, 10) || 1;
    if (!id) return Promise.reject('missing-id');

    const payload = { id: id, quantity: quantity, ...extras };

    return fetch(API.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)));
  }

  function bindProductForms() {
    qsa(SELECTORS.productForm).forEach(form => {
      if (form.__elAddBound) return;
      form.__elAddBound = true;

      form.addEventListener('submit', async function (ev) {
        // Only intercept when submission triggered via normal add-to-cart (not quick buy flows that we intend to allow)
        try { ev.preventDefault(); ev.stopImmediatePropagation(); } catch(e){}
        if (isAdding) return;
        isAdding = true;

        const submitBtn = form.querySelector(SELECTORS.addToCartBtn) || form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.setAttribute('disabled','disabled');

        const img = qs(SELECTORS.productImage, form) || qs(SELECTORS.productImage);
        const cartIcon = findCartIcon();

        try {
          const added = await addToCartAjax(form);
          // animation
          await flyToCartAnimation(img, cartIcon);
          showAddedBadge(cartIcon);
          await refreshCartUI(true);
        } catch (err) {
          console.error('addToCartAjax error', err);
          // fallback: for safety, submit normally if server-side required
          try { form.removeEventListener('submit', arguments.callee); form.submit(); } catch(e){}
        } finally {
          isAdding = false;
          if (submitBtn) submitBtn.removeAttribute('disabled');
        }
      }, true);
    });
  }

  /* ====================== STICKY BUY (mobile) ====================== */
  (function stickyBuy() {
    const STICKY_ID = 'el-sticky-buy';
    const BTN_SELECTOR = '#elStickyGo';
    const QBS_ADD_ID = 'qbsAdd';      // id inside quick-buy sheet that actually adds
    const QBS_SHEET_ID = 'qbsSheet';
    const MODAL_OPEN_EVENTS = ['qbs:open','qbs:opened','qbs:opened']; // events we may dispatch/listen

    const stickyEl = document.getElementById(STICKY_ID);
    if (!stickyEl) return;
    function isMobile() { return window.innerWidth <= MOBILE_BREAK; }
    if (!isMobile()) { stickyEl.style.display = 'none'; return; }

    function measureSticky() {
      const h = Math.round(stickyEl.getBoundingClientRect().height || 84);
      document.documentElement.style.setProperty('--el-sticky-h', (h+2) + 'px');
    }
    measureSticky();
    addEventListener('resize', measureSticky, { passive: true });

    function setAddMode(on) {
      const b = qs(BTN_SELECTOR);
      if (!b) return;
      b.dataset.mode = on ? 'add' : '';
      const label = b.querySelector('.el-label');
      if (label) label.textContent = on ? 'ADICIONAR AO CARRINHO' : '✦ COMPRAR AGORA';
    }

    // Listen for sheet state changes (themes may dispatch)
    addEventListener('qbs:opened', () => setAddMode(true), { passive:true });
    addEventListener('qbs:open', () => setAddMode(true), { passive:true });
    addEventListener('qbs:closed', () => setAddMode(false), { passive:true });

    // robust open function: tries function, event, fallback to classes
    function openQbsRobust() {
      // 1) explicit function
      if (typeof window.qbsOpen === 'function') {
        try { window.qbsOpen(); return true; } catch(e){}
      }
      // 2) dispatch event
      try { dispatchEvent(new Event('qbs:open')); } catch(e){}
      // 3) fallback toggle classes
      const s = document.getElementById(QBS_SHEET_ID), o = document.getElementById('qbsOverlay') || document.getElementById('qbsOverlay');
      if (s && o) {
        o.classList.add('open'); s.classList.add('open'); s.setAttribute('aria-hidden','false');
        try { dispatchEvent(new Event('qbs:opened')); } catch(e){}
        return true;
      }
      // 4) poll for function/sheet
      let tries = 0;
      const iv = setInterval(()=> {
        tries++;
        if (typeof window.qbsOpen === 'function') { try{ window.qbsOpen(); clearInterval(iv); } catch(_){} }
        else if (document.getElementById(QBS_SHEET_ID) && document.getElementById('qbsOverlay')) { openQbsRobust(); clearInterval(iv); }
        if (tries >= 12) clearInterval(iv);
      }, 120);
      return true;
    }

    // Delegated click (capture) to ensure we run before theme handlers
    document.addEventListener('click', function (evt) {
      const target = evt.target;
      const btn = target.closest ? target.closest(BTN_SELECTOR) : null;
      if (!btn) return;
      if (!isMobile()) return; // do nothing on desktop

      // prevent theme's default submit/behavior
      try { evt.preventDefault(); evt.stopPropagation(); } catch(e){}

      // If sticky is in ADD mode -> simulate clicking the sheet's add button
      if (btn.dataset.mode === 'add') {
        const qbsAddBtn = document.getElementById(QBS_ADD_ID) || qs('#' + QBS_ADD_ID);
        if (qbsAddBtn) {
          try { qbsAddBtn.click(); return; } catch(e){}
        }
        // fallback: wait until qbsAdd appears
        elReady('#' + QBS_ADD_ID, 2500).then(el => el && el.click()).catch(()=>{});
        return;
      }

      // if sheet open already, change mode
      const sheet = document.getElementById(QBS_SHEET_ID);
      if (sheet && sheet.classList.contains('open')) { setAddMode(true); return; }

      // otherwise open sheet robustly
      openQbsRobust();
    }, true);

    // Also bind common PDP CTAs to open quick-buy instead of submit on mobile
    function bindPdpCTAs() {
      qsa(SELECTORS.buyNowCTAs).forEach(b => {
        if (!b || b.__qbsLinked) return;
        b.__qbsLinked = true;
        b.addEventListener('click', function (e) {
          if (!isMobile()) return; // keep desktop native checkout
          try { e.preventDefault(); e.stopImmediatePropagation(); } catch(e){}
          openQbsRobust();
        }, true);
      });
    }
    bindPdpCTAs();
    new MutationObserver(() => bindPdpCTAs()).observe(document.documentElement, { childList:true, subtree:true });

    // if sheet exists and is already open
    elReady('#' + QBS_SHEET_ID, 4000).then(s => { if (s && s.classList.contains('open')) setAddMode(true); }).catch(()=>{});
  })();

  /* ====================== PDP CTA BIND (general) - idempotent ====================== */
  (function bindGlobalCTAs(){
    function attach() {
      qsa(SELECTORS.buyNowCTAs).forEach(b => {
        if (!b || b.__elBound) return;
        b.__elBound = true;
        b.addEventListener('click', function(e){
          // only intercept on mobile (we open quickbuy sheet)
          try {
            if (window.innerWidth > MOBILE_BREAK) return;
            e.preventDefault(); e.stopImmediatePropagation();
          } catch(_) {}
          // open sheet robustly (some themes expose qbsOpen)
          if (typeof window.qbsOpen === 'function') {
            try { window.qbsOpen(); return; } catch(e){}
          }
          try { dispatchEvent(new Event('qbs:open')); } catch(e){}
        }, true);
      });
    }
    document.addEventListener('DOMContentLoaded', attach);
    document.addEventListener('shopify:section:load', attach);
    new MutationObserver(() => attach()).observe(document.documentElement, { childList:true, subtree:true });
  })();

  /* ====================== INIT ====================== */
  document.addEventListener('DOMContentLoaded', function(){
    try {
      bindProductForms();
      refreshCartUI(false);
      // listen to external events/theme events to rebind
      document.addEventListener('shopify:section:load', function(){ bindProductForms(); refreshCartUI(false); });
      document.addEventListener('shopify:section:select', function(){ bindProductForms(); });
      window.addEventListener('el:cart:updated', function(){ /* placeholder if needed */ });
      // expose helpers if you want to call manually
      window.EL_BIND_PRODUCT_FORMS = bindProductForms;
      window.EL_REFRESH_CART = refreshCartUI;
    } catch(e){ console.error('init custom.js error', e); }
  });

  // safety: rebind on dynamic changes
  new MutationObserver(() => { bindProductForms(); }).observe(document.documentElement, { subtree:true, childList:true });

  /* ====================== minimal CSS injection for badge (if not present in theme CSS) ====================== */
  (function injectStyles(){
    const id = 'el-custom-js-style';
    if (document.getElementById(id)) return;
    const css = `
      .el-added-badge{ position:fixed; right:20px; bottom:100px; background:linear-gradient(90deg,#1ee081,#0ea5a4); color:#02121a; padding:8px 12px; border-radius:20px; font-weight:800; z-index:999999; box-shadow:0 10px 30px rgba(0,0,0,.35); transform:translateY(0); opacity:0; transition:opacity .35s, transform .35s; }
    `;
    const s = document.createElement('style'); s.id = id; s.appendChild(document.createTextNode(css)); document.head.appendChild(s);
  })();

})();
